/**
* Filter selector for categories and experiences
*
* This function create an selector
*
*/

export const results = (state) => state.filterSectionReducer;
export const resData = (state) => state.filterSectionReducer.data.data;
